
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';
import merge from 'lodash/merge';

/**
 * `Query` type.
 */

type Query = {
  collectionId: string,
  locale: string,
  params: {
    filter?: {
      [key: string]: any
    },
    limit: number,
    page: number
  }
};

/**
 * Export `paginationLimit` constant.
 */

export const paginationLimit = 24;

/**
 * Export `fetchProductsCollection`.
 */

export async function fetchProductsCollection(query: Query) {
  const { collectionId, locale, params } = query;
  const endpoint = getApiEndpoint('getProducts');

  if (!params.page) {
    return;
  }

  try {
    const currentPage = params?.page ?? 1;
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale),
      params: {
        ...params,
        filter: merge({}, { collection: collectionId }, params?.filter)
      }
    });

    return {
      data: data?.data,
      nextPage: +currentPage + 1,
      total: data?.total
    };
  } catch (error) {
    handleRequestError(error);
  }
}
